import { createSlice } from "@reduxjs/toolkit"


const EmployerInitialState:any = {
    placements:[],
}

const EmployerSlice = createSlice({
    name:"Employer",
    initialState:EmployerInitialState,
    reducers:{
        setPlacements:(state,action) => {
            state.placements = action.payload
        },
    }

})
export default EmployerSlice